import { render, staticRenderFns } from "./CustomerDataTableRow.vue?vue&type=template&id=106104d4&"
import script from "./CustomerDataTableRow.vue?vue&type=script&lang=js&"
export * from "./CustomerDataTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports